import {EVENT_FAVIRIATE_CHANGE, FROM_LIBRARY, FROM_TRASH, MENU_SEPARATOR} from "@/Const";
import {t} from "i18next";
import {
    IconAddToFavor,
    IconAddToProject,
    IconChangeSource, IconCopyHighlight,
    IconCopyLink,
    IconDelete,
    IconExportHighlights,
    IconForeverDelete, IconHiddenFromLibrary,
    IconImportHighlights,
    IconInfoMenu,
    IconLocation,
    IconMakeCopy,
    IconMakeCopy_L2,
    IconManagerTags,
    IconMenuExportItem, IconMoveTo,
    IconOpenInFullscreen,
    IconOpenInPopup,
    IconOpenInSystemExplorer,
    IconOpenLink,
    IconRemoveFavor,
    IconRename,
    IconRestore,
    IconVersionHistory,
    IconViewAllHighlight, IconVisibleFromLibrary
} from "@/Icon";
import Icon from '@ant-design/icons';
import {
    generateUUID2,
    getImagePathWithTheme,
    getItem,
    imgPathPerfix,
    isSupportVideoAnnoUrl,
    isYoutubeUrl
} from "@/utils";
import {getFavorChildrenMenu, isMac, updateFavorToFolder} from "@/Utility";
import React from "react";
import {updateNote} from "@model/note";
import {postMessage} from "@/common/event";
import {ENoteAction} from "@/views/Note/NoteItem/NoteItemIndex";

export const createLibraryItemMenu = (from:any,isShowChecked:any,data:any,callback:any)=>{
    const szUrl = data.link || data.fileName || data.url;//每个地方都不一样的参数。。。。。
    let menu:any=[];
    if (from == FROM_TRASH){
        menu.push({
            label: t('Restore'),
            key: "restore",
            icon: <IconRestore/>
        });
        menu.push({label: t('Delete forver'),
            key: "deleteForever",
            icon: <IconForeverDelete/>
        })
        return menu;
    }

    if (isShowChecked){
        menu.push({
            label: t("Add to project"),
            key: 'addToProjectChecked',
            icon: <IconAddToProject/>
        })

        menu.push({
            label: t("Manage tags"),
            key: 'managerTagsChecked',
            icon: <IconManagerTags/>
        })

        menu.push({
            label: t("Delete"),
            key: 'deleteChecked',
            icon: <IconDelete/>
        })
        return menu;
    }


    if (data.type == 'card'){
        if (from == FROM_LIBRARY){
            menu.push({
                label: t("Open in popup"),
                key: 'openInPopup',
                icon: <IconOpenInPopup/>
            })
            menu.push({
                label: t("Open in fullscreen"),
                key: 'openInFullscreen',
                icon: <IconOpenInFullscreen/>
            })
            menu.push({
                key:generateUUID2(),
                type:'divider'
            })
        }

        menu.push({
            label: t("ExportPDF"),
            key: 'exportCardPdf',
            icon: <IconMenuExportItem/>
        })

        menu.push({
            label: t("ExportMarkdown"),
            key: 'exportMarkdown',
            icon: <IconMenuExportItem/>
        })

        menu.push({
            label: t("Share1"),
            key: 'shareCard',
            icon: <IconMenuExportItem/>
        })

        menu.push({
            key:'seper_0',
            type:'divider'
        })

        if (data.type != 'journal'){
            menu.push({
                label: t("Rename"),
                key: 'rename',
                icon: <IconRename/>
            })
        }

        menu.push({
            label: data.isFavirated === 1?t('Cancel favor'):t("Add to Favorites"),
            key: 'favor',
            icon: data.isFavirated === 1?<IconRemoveFavor/>:<IconAddToFavor/>,
            children:getFavorChildrenMenu(data.isFavirated,callback)
        },)

        if (data.type != 'journal') {
            menu.push({
                label: t("Generic copy"),
                key: 'makeACopy',
                icon: <IconMakeCopy/>
            })
        }
    }else if (data.type == 'journal'){
        menu.push({
            label: t("ExportPDF"),
            key: 'exportCardPdf',
            icon: <IconMenuExportItem/>
        })

        menu.push({
            label: t("ExportMarkdown"),
            key: 'exportMarkdown',
            icon: <IconMenuExportItem/>
        })

        menu.push({
            key:'seper_0',
            type:'divider'
        })
    }
    else if (data.type == 'pdf'){ /**********pdf菜单************/
        if (from == FROM_LIBRARY){
            menu.push({
                label: t("Open in popup"),
                key: 'openInPopup',
                icon: <IconOpenInPopup/>
            })
            menu.push({
                label: t("Open in fullscreen"),
                key: 'openInFullscreen',
                icon: <IconOpenInFullscreen/>
            })
            menu.push({
                key:generateUUID2(),
                type:'divider'
            })
        }
        menu.push({
            label: t("ExportPDF"),
            key: 'exportPdf',
            icon: <IconMenuExportItem/>
        })

        menu.push({
            label: t("Rename"),
            key: 'rename',
            icon: <IconRename/>
        })

        menu.push({
            label: t("View all highlights"),
            key: 'viewAllHighlights',
            icon: <IconViewAllHighlight/>
        })

        // menu.push({
        //     label: t("Change source"),
        //     key: 'changeSource',
        //     icon: <IconChangeSource/>
        // })

    }else if (data.type == 'video' || data.type == 'bilibili' || data.type == 'youtube'){
        if (from == FROM_LIBRARY){
            menu.push({
                label: t("Open in popup"),
                key: 'openInPopup',
                icon: <IconOpenInPopup/>
            })
            menu.push({
                label: t("Open in fullscreen"),
                key: 'openInFullscreen',
                icon: <IconOpenInFullscreen/>
            })
            menu.push({
                key:generateUUID2(),
                type:'divider'
            })
        }

        menu.push({
            label: t("Rename"),
            key: 'rename',
            icon: <IconRename/>
        })

        if (!isSupportVideoAnnoUrl(szUrl)){//非在线视频
            menu.push({
                label: t("Export video"),
                key: 'exportVideo',
                icon: <IconMenuExportItem/>
            })
        }


        // menu.push({
        //     label: t("Change source"),
        //     key: 'changeSource',
        //     icon: <IconChangeSource/>
        // })
    }else if (data.type == 'audio'){
        if (from == FROM_LIBRARY){
            menu.push({
                label: t("Open in popup"),
                key: 'openInPopup',
                icon: <IconOpenInPopup/>
            })
            menu.push({
                label: t("Open in fullscreen"),
                key: 'openInFullscreen',
                icon: <IconOpenInFullscreen/>
            })
            menu.push({
                key:generateUUID2(),
                type:'divider'
            })
        }
        menu.push({
            label: t("Rename"),
            key: 'rename',
            icon: <IconRename/>
        })

        menu.push({
            label: t("Export audio"),
            key: 'exportAudio',
            icon: <IconMenuExportItem/>
        })
    }else if (data.type == 'videoAnno' || data.type == 'audioAnno'){
        menu.push({
            label: t("Locate highlight"),
            key: 'locateHighlight',
            icon: <IconLocation/>
        })

        menu.push({
            label: t("Change source"),
            key: 'changeSource',
            icon: <IconChangeSource/>
        })
    } else if (data.type == 'pdfAnno'){
        menu.push({
            label: t("Locate highlight"),
            key: 'locateHighlight',
            icon: <IconLocation/>
        })

        menu.push({
            label: t("CopyHighlightText"),
            key: 'copyHighlightText',
            icon: <IconCopyHighlight/>
        })

        menu.push({
            label: t("Change source"),
            key: 'changeSource',
            icon: <IconChangeSource/>
        })
    }else if (data.type == 'cardAnno'){
        menu.push({
            label: t("Locate highlight"),
            key: 'locateHighlight',
            icon: <IconLocation/>
        })

        menu.push({
            label: t("CopyHighlightText"),
            key: 'copyHighlightText',
            icon: <IconCopyHighlight/>
        })
    }else if (data.type == 'webLink'){
        menu.push({
            label: t("Rename"),
            key: 'rename',
            icon: <IconRename/>
        })

        menu.push({
            label: t("Open link"),
            key: 'openLink',
            icon: <IconOpenLink/>
        })
    }
    else{
        if (!isYoutubeUrl(data.url)){
            if (data.type != 'journal'){
                menu.push({
                    label: t("Rename"),
                    key: 'rename',
                    icon: <IconRename/>
                })
            }

            if (data.type == 'pdf' || data.type == 'video' || data.type == 'audio' || data.type == 'file'){
                menu.push({
                    label: t("Export file"),
                    key: 'exportFile',
                    icon: <IconMenuExportItem/>
                })
            }
        }
    }


    menu.push({
        label: t("Show info"),
        key: 'showInfo',
        icon: <IconInfoMenu/>
    })

    if (data.type == 'card' || data.type == 'journal') {
        menu.push({
            label: <div>{t("Version history")}<label className={'beta'}>{'Beta'}</label></div>,
            key: 'versionHistory',
            icon: <IconVersionHistory/>
        })

        if (data.type == 'card'){
            menu.push({
                label: data.isHidden == 1?t("Make visible in library"):t("Hide from library"),
                key: 'hiddenVisibleFromLibrary',
                icon: data.isHidden == 1?<IconVisibleFromLibrary/>:<IconHiddenFromLibrary/>
            })
        }
    }

    if (data.type != 'card' && data.type != 'videoAnno' &&
        data.type != 'pdfAnno'  && data.type != 'cardAnno' &&
        data.type != 'youtube' && data.type != 'bilibili' && data.type != 'webLink' && data.type != 'journal') {
        if (!isSupportVideoAnnoUrl(szUrl)) {//非在线视频
            menu.push({
                label: isMac() ? t("Show in finder") : t("Show in system exporler"),
                key: 'showInSystemExporler',
                icon: <IconOpenInSystemExplorer/>
            })
        }
    }

    if (data.type == 'video' || data.type == 'youtube' || data.type == 'bilibili' || data.type == 'baidu' || data.type == 'audio'){
        menu.push({
            key:generateUUID2(),
            type:'divider'
        })

        menu.push({
            label: t("Import highlights"),
            key: 'importHighlights',
            icon: <IconImportHighlights/>
        })

        menu.push({
            label: t("Export highlights"),
            key: 'exportHighlights',
            icon: <IconExportHighlights/>
        })

        menu.push({
            label: t("Copy to clipboard"),
            key: 'copyToClipboard',
            icon: <IconMakeCopy/>
        })

        menu.push({
            key:generateUUID2(),
            type:'divider'
        })

        menu.push({
            label: t("Import transcript"),
            key: 'importTranscript',
            icon: <IconImportHighlights/>
        })

    }


    menu.push({
        key:generateUUID2(),
        type:'divider'
    })

    if (data.type == 'webLink'){
        menu.push({
            label: t("CopyOriginalLink"),
            key: 'copyOriginLink',
            icon: <IconCopyLink/>
        })
    }else{
        menu.push({
            label: t("Copy link"),
            key: 'copyLink',
            icon: <IconCopyLink/>
        })
    }

    menu.push({
        label: t("Manage tags"),
        key: 'managerTags',
        icon: <IconManagerTags/>
    })

    menu.push({
        label: t("Add to project"),
        key: 'addToProject',
        icon: <IconAddToProject/>
    })

    //日记没有删除...
    if (data.type != 'journal'){
        menu.push({
            key:'seper_2',
            type:'divider'
        })

        menu.push({
            label: t("Delete"),
            key: 'delete',
            icon: <IconDelete/>
        })
    }

    return menu;
}


export const createProjectItemMenu = (data:any,callback)=>{
    const menu = [
        {
            label: t("Rename"),
            key: 'rename',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "menu_rename.png"}/>}/>
        },
        // {
        //   label: t("Move to folder"),
        //   key: ENoteAction.moveToFolder,
        //   icon: <IconMoveToFolder/>
        // },
        {
            label:data.isFavirated === 1?t('Cancel favor'):t("Add to Favorites"),
            //     <span style={{display:'inline-block'}} onClick={(event)=>{
            //   if (data.isFavirated == 0) {
            //     event.stopPropagation();
            //     setIsShowContextMenu(false);
            //     data.isFavirated = 1;
            //     data.favirateTime = new Date().getTime();
            //
            //     updateNote(data).then(res=>{
            //       postMessage(EVENT_FAVIRIATE_CHANGE);
            //       setMenuItems(createMenu());
            //     })
            //   }
            // }}>{data.isFavirated === 1?t('Cancel favor'):t("Add to Favorites")}</span>,
            key: 'favor',
            icon: data.isFavirated === 1?<Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_remove_favor.png"}/>}/>:<Icon component={() => <img className='img-14 mr-4' src={getImagePathWithTheme("add_to_favor")}/>}/>,
            children:getFavorChildrenMenu(data.isFavirated,async (key)=>{
                if (callback){
                    callback(key);
                }
            }),
        },
        {
            label: t("Generic copy"),
            key: 'makeCopy',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_makecopy.png"}/>}/>
        },
        {
            label: t("Show info"),
            key: 'showInfo',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "context_menu_info.png"}/>}/>
        },
        getItem(<div className={'ml-4'}>{t("Version history")}<label className={'beta'}>{'Beta'}</label></div>, 'versionHistory', <IconVersionHistory/>, undefined, undefined, () => {
            //历史记录
            window.showDialogProjectHistory(data.id, (newProject: any) => {

            });
        }),
        {
            label: t("Change thumbnail"),
            key: 'changeThumbnail',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "context_menu_changethumbnail.png"}/>}/>
        },

        getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

        }),
        {
            label: t("Copy link"),
            key: 'copyLink',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "context_menu_link.png"}/>}/>
        },
        {
            label: t("Manage tags"),
            key: 'manageTags',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_manage_tag.png"}/>}/>
        },

        getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

        }),

        {
            label: t("Delete"),
            key: 'delete',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_delete.png"}/>}/>
        }
    ]

    return menu;
}

export function createBoardItemMenu(data:any,callback:any){
    const menu = [
        {
            label: t("Rename"),
            key: 'rename',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "menu_rename.png"}/>}/>
        },
        {
            label:data.isFavirated === 1?t('Cancel favor'):t("Add to Favorites"),
            key: 'favor',
            icon: data.isFavirated === 1?<Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_remove_favor.png"}/>}/>:<Icon component={() => <img className='img-14 mr-4' src={getImagePathWithTheme("add_to_favor")}/>}/>,
            children:getFavorChildrenMenu(data.isFavirated,async (key)=>{
                if (callback){
                    callback(key);
                }
            }),
        },
        {
            label: t("Generic copy"),
            key: 'makeCopy',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_makecopy.png"}/>}/>
        },
        {
            label: t("Show info"),
            key: 'showInfo',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "context_menu_info.png"}/>}/>
        },

        {
            label: t("Move to"),
            key: 'moveTo',
            icon:  <IconMoveTo/>
        },
        getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

        }),
        {
            label: t("Copy link"),
            key: 'copyLink',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "context_menu_link.png"}/>}/>
        },
        {
            label: t("Manage tags"),
            key: 'manageTags',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_manage_tag.png"}/>}/>
        },

        getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

        }),

        {
            label: t("Delete"),
            key: 'delete',
            icon: <Icon component={() => <img className='img-14 mr-4' src={imgPathPerfix() + "item_delete.png"}/>}/>
        }
    ]

    return menu;
}